import type { Shadows } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import './augmentation';
import { components } from './components';
import { darkPalette, lightPalette } from './palette';
import { typography } from './typography';

export const theme = createTheme({
  cssVariables: { colorSchemeSelector: 'class' },
  colorSchemes: {
    light: { palette: lightPalette },
    dark: { palette: darkPalette },
  },
  // Mirrors the prototype's media queries: ≤640 compact, ≤980 single-column dashboards,
  // ≤1024 off-canvas sidebar, ≤1180 two-column KPI grids.
  breakpoints: { values: { xs: 0, sm: 641, md: 981, lg: 1025, xl: 1181 } },
  // Numeric because MUI scales `sx` radii by it; 3 matches `radius.control`.
  shape: { borderRadius: 3 },
  // MUI elevations resolve to no shadow so a stray `elevation={n}` can't add a heavy one; the
  // soft shadows come from the `md.shadow*` tokens that surfaces opt into.
  shadows: Array.from({ length: 25 }, () => 'none') as unknown as Shadows,
  typography,
  components,
});
